export default {
  type: "python-free",
  layout: "layouts/uk-coding",
  components: [
    require("fixtures/components/instructions.json"),
    require("fixtures/components/python-free-editor").default,
  ],
};
